import { BaseResponseDto } from '@/models/dtos/baseReponseDto'
import { UserDto } from '@/models/dtos/userDto'
import { EmployeeTypeDto } from '@/models/dtos/employeeTypeDto'
import axios from 'axios'
import { Endpoints } from './_endpoints'

export abstract class UserService {
  static async getUsers(): Promise<UserDto[]> {
    const result = await axios.get<BaseResponseDto<UserDto[]>>(Endpoints.account.getUsers)

    if (!result.data.dto) return []

    return result.data.dto
  }

  static async GetEmployeeTypes(): Promise<EmployeeTypeDto[]> {
    const result = await axios.get<BaseResponseDto<EmployeeTypeDto[]>>(Endpoints.account.getEmployeeTypes)

    if (!result.data.dto) return []

    return result.data.dto
  }

  static async changePassword(oldPassword: string, newPassword: string): Promise<void> {
    await axios.get<BaseResponseDto<any>>(Endpoints.account.changePassword, {
      params: {
        oldPassword: oldPassword,
        newPassword: newPassword
      }
    })
  }
}
